import { GetTtsDocument, Speaking_Rate } from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getTts = async (
  text: string,
  speakingRate: Speaking_Rate = Speaking_Rate.Medium
) => {
  const response = await apolloClient.query({
    query: GetTtsDocument,
    variables: {
      text,
      speakingRate,
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.tts) {
    return response.data.tts;
  }

  throw new SentryGraphQLError('api.tts.getTts', response);
};

export default {
  getTts,
};
